var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 26.001,
    viewBox: "0 0 25 26.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2173eb",
    d: "M1,26a1,1,0,0,1-1-1V19.087a1,1,0,0,1,1-1H24a1,1,0,0,1,1,1V25a1,1,0,0,1-1,1Zm18.048-3.957a1.788,1.788,0,1,0,1.786-1.7A1.744,1.744,0,0,0,19.048,22.044ZM1,16.958a1,1,0,0,1-1-1V10.044a1,1,0,0,1,1-1H24a1,1,0,0,1,1,1v5.914a1,1,0,0,1-1,1ZM19.048,13a1.788,1.788,0,1,0,1.786-1.7A1.744,1.744,0,0,0,19.048,13ZM1,7.914a1,1,0,0,1-1-1V1A1,1,0,0,1,1,0H24a1,1,0,0,1,1,1V6.914a1,1,0,0,1-1,1ZM19.048,3.956a1.788,1.788,0,0,0,3.571,0,1.788,1.788,0,0,0-3.571,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServer);
export default __webpack_public_path__ + "static/media/server.4113e342.svg";
export { ForwardRef as ReactComponent };